/**
 * CMS Client for Akut Vikaren ApS
 */

const API_BASE = 'https://api.dev.auxo.dk/public';

// Fallback data in case of offline/network issues
export const fallbackNavigation = [
  { id: '1', title: 'Forside', path: '/', order: 1 },
  { id: '2', title: 'Bostøtte', path: '/bostotte', order: 2 },
  { id: '3', title: 'Aflastning – hjemme og ude', path: '/aflastning', order: 3 },
  { id: '4', title: 'Akut anbringelse', path: '/akut-anbringelse', order: 4 },
  { id: '5', title: 'Bliv vikar', path: '/bliv-vikar', order: 5 },
  { id: '6', title: 'Kontakt', path: '/kontakt', order: 6 },
];

export const fallbackGalleries = {
  'bostotte': {
    title: 'Billeder fra Bostøtte',
    gallery_key: 'bostotte',
    description: 'Billeder af relationer, hverdagsstøtte og tryghed i hjemlige rammer.',
    images: [
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-borger-med-hund.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-hverdagsstoette-i-hjemmet.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/bostotte-hverdag.jpg',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/bostotte-samtale.jpg',
    ]
  },
  'aflastning': {
    title: 'Billeder fra Aflastning',
    gallery_key: 'aflastning',
    description: 'Relationsarbejde, tryghed og meningsfulde aktiviteter både hjemme og ude.',
    images: [
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-borger-og-medarbejder-udendoers.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-borger-og-medarbejder.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-borger-med-rollator.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/aflastning-aktivitet.jpg',
    ]
  },
  'akut-anbringelse': {
    title: 'Billeder fra Akut Anbringelse',
    gallery_key: 'akut-anbringelse',
    description: 'Hurtig indsats, omsorgsfuld modtagelse og professionelt pædagogisk personale.',
    images: [
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-samvaer-paa-tvaers-af-generationer.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-vikaren-naervaer-og-samtale.webp',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-indsats-tryghed.jpg',
      'https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/akut-anbringelse-omsorg.jpg',
    ]
  }
};

/**
 * Fetch all navigation items from CMS
 */
export async function getCmsNavigation() {
  try {
    const res = await fetch(`${API_BASE}/content/navigation_items`);
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return data.sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
    }
    return fallbackNavigation;
  } catch (err) {
    console.warn('CMS Navigation load failed, using fallback:', err);
    return fallbackNavigation;
  }
}

/**
 * Fetch all CMS galleries
 */
export async function getCmsGalleries() {
  try {
    const res = await fetch(`${API_BASE}/content/gallery`);
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return data;
    }
    return Object.values(fallbackGalleries);
  } catch (err) {
    console.warn('CMS Galleries load failed, using fallback:', err);
    return Object.values(fallbackGalleries);
  }
}

/**
 * Fetch single CMS gallery by key
 */
export async function getCmsGalleryByKey(key) {
  try {
    const galleries = await getCmsGalleries();
    const found = galleries.find(g => g.gallery_key === key || g.slug?._ === key || g.slug === key);
    if (found) return found;
    return fallbackGalleries[key] || null;
  } catch (err) {
    return fallbackGalleries[key] || null;
  }
}

/**
 * Helper to build Cloudflare resized image URLs
 */
export function getOptimizedImageUrl(url, width = 800, quality = 85) {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('https://assets.auxodev.dk')) return url;
  if (url.includes('/cdn-cgi/image/')) return url;

  return url.replace(
    'https://assets.auxodev.dk/',
    `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
  );
}
